import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  Dummyimage1,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
// import { useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { checkPermission } from "../redux/api/PermissionManager";

const WishList = () => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");

  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    search: paginationData?.[path]?.search ?? "",
  });
  const [list, setList] = useState([]);
  const [addPopup, setAddPopup] = useState(false);

  const handleChangeFilter = (name, val) => {
    setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  useEffect(() => {
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [page, selectedFilter]);

  const getList = async (pageNumber = 1) => {
    let res = await get(
      `${URLS.WISHLIST}?search=${selectedFilter.search}&page=${pageNumber}`
    );
    console.log("wishlist res", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setList(res?.data ?? []);
    }
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: "Hotel Category",
        accessor: "hotel_category",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Property",
        accessor: "property_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap">
              <p className="primary pointer">{value}</p>
              {/* <p className="primary pointer">{row.original?.code}</p> */}
            </div>
          );
        },
      },
      {
        Header: "Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap">
              <p className="primary pointer">{value}</p>
              {/* <p className="primary pointer">{row.original?.code}</p> */}
            </div>
          );
        },
      },
      {
        Header: " Location",
        accessor: "area",
        Cell: ({ value, row }) => {
          return <p>{`${value},${row.original?.city}`}</p>;
        },
      },
      {
        Header: " Wishlist Count",
        accessor: "wishlist_count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Property Image",
        accessor: "property_image",
        Cell: ({ value, row }) => {
          return (
            <img src={value ?? Dummyimage1} alt="image" className="list-img" />
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/wishlistview", {
                    state: { property: row.original, type: "view" },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-WISH_LIST") ? [...d, action] : d;
  }, [page]);

  const handleSend = () => {
    toast.success("Message sent successfully!");
    setAddPopup(false);
  };

  return (
    <div>
      <Topbar header={"Wish List"} />
      <div className="d-flex ac-jb">
        <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
          Total:{count}
        </h2>
        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                handleChangeFilter("search", e.target.value);
              }}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
              value={selectedFilter.search}
            />
            <img alt="" src={Search_icon} className="search" />
          </div>
          {(checkPermission("CAN-ADD-WISH_LIST") ||
            checkPermission("CAN-EDIT-WISH_LIST")) && (
            <button
              className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white push-btn "
              onClick={() => setAddPopup(true)}
            >
              {" "}
              Push Notification
            </button>
          )}
          {/* } */}
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={list}
        show={true}
      />
      {addPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb">
              <p className="f4 text-start  fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 "></p>
              <CloseSharpIcon
                onClick={() => {
                  setAddPopup(false);
                }}
                className="pointer"
              />
            </div>
            <div className="d-flex ac-js mt-3">
              <div className="w-100">
                <div className="d-flex as-js  ">
                  <p className="fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-18">
                    Description
                  </p>
                </div>

                <div>
                  <div>
                    <div className="d-flex ae-jb  p-1">
                      <textarea
                        style={{ maxHeight: "80px" }}
                        className="mb-3 w-100 roles-input input-border"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex ac-je mt-4">
              <button
                className="submit-btn f2 w-40 p-2 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15"
                onClick={handleSend}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WishList;
